import React from 'react'

function Team() {
    return ( 
        <div className='container mt-5'>
            <div className='row text-center mb-5'>
                <h2>People</h2>
                <div className='col-6'>
                    <img src='media/nithin-kamath.jpg' alt='owner' style={{borderRadius: "100%", height:"300px" , marginLeft:"90px"}}></img>
                    <h4 className='mt-3' style={{marginLeft:"80px"}}>Nithin Kamath</h4>
                    <span style={{marginLeft:"80px"}}>Founder, CFO</span>
                </div>
                <div className='col-6'>
                    <article className='mt-5'>Nithin bootstrapped and founded Zerodha in 2010 to overcome the hurdles he faced during his decade long stint as a trader. Today, Zerodha has changed the landscape of the Indian broking industry.

He is a member of the SEBI Secondary Market Advisory Committee (SMAC) and the Market Data Advisory Committee (MDAC).

Playing basketball is his zen.</article>
                    
                </div>
            </div>
        </div>
     );
}

export default Team;
